export default "__VITE_ASSET__42014ecc__"